import React, { useState, useEffect, useRef } from 'react';
import Page1 from './components/about/Page1';
import Page2 from './components/about/Page2';
import Page3 from './components/about/Page3';
import Navbar from "./Router";
import styles from "./css/about.css";
import setBodyColor from './js/setBodyColor';
import setButtonColor from './js/setButtonColor';
import themeColor from './hooks/ThemeColor';

const About = () => {

  const [currentPage, setCurrentPage] = useState(0);
  const containerRef = useRef(null);
  const totalPages = 3;
  const theme = themeColor(true);

  const nextPage = (e) => {
    e.preventDefault();
    console.log('clicked')
    if (currentPage < totalPages - 1) {
      scrollToPage(currentPage + 1);
    }
  };

  const prevPage = (e) => {
    e.preventDefault();
    if (currentPage > 0) {
      scrollToPage(currentPage - 1);
    }
  };

  // handle scroll events
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const pageWidth = container.clientWidth;
      const newPage = Math.round(scrollLeft / pageWidth);
      setCurrentPage(newPage);
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  // smooth scroll to specific page
  const scrollToPage = (pageIndex) => {
    const container = containerRef.current;
    if (!container) return;

    const pageWidth = container.clientWidth;
    container.scrollTo({
      left: pageIndex * pageWidth,
      behavior: 'smooth'
    });
  };

  // handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft' && currentPage > 0) {
        scrollToPage(currentPage - 1);
      } else if (e.key === 'ArrowRight' && currentPage < totalPages - 1) {
        scrollToPage(currentPage + 1);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentPage]);

  setButtonColor({ borderColor: "rgb(255 255 255 / 0.3)", color: "#fff"});

  return (
    <div id="about">
      <Navbar />
      <div className="flex w-full flex-col relative overflow-hidden">
        {/* main scrolling container*/}
        <div
          ref={containerRef}
          className="flex h-full overflow-x-auto overflow-y-hidden snap-x snap-mandatory scrollbar-hide"
          style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            WebkitScrollbar: { display: 'none' }
          }}
        >
          <Page1 />
          <Page2 />
          <Page3 />
        </div>

        {/* scroll hint */}
        {currentPage === 0 && (
          <div className="arrows fixed bottom-8 right-8 text-white/60 text-sm cursor-pointer z-20" onClick={nextPage}>
            <img src="assets/white-arrow.png" alt="Swipe up or use arrow keys" />
          </div>
        )}
        {currentPage === 1 && (
          <div className="arrows-both fixed bottom-8 right-8 text-white/60 text-sm cursor-pointer z-20">
            <div className="arrows arrow-back" onClick={prevPage}>
              <img src="assets/white-arrow.png" alt="Swipe up or use arrow keys" />
            </div>
            <div className="arrows" onClick={nextPage}>
              <img src="assets/white-arrow.png" alt="Swipe up or use arrow keys" />
            </div>
          </div>
        )}
        {currentPage === 2 && (
          <div className="arrows arrow-back fixed bottom-8 right-8 text-white/60 text-sm cursor-pointer z-20" onClick={prevPage}>
            <img src="assets/white-arrow.png" alt="Swipe up or use arrow keys" />
          </div>
        )}

      </div>
    </div>
  );

};


export default About;